export function BackIcon() {
    return (
        <svg
            width={20}
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 219.151 219.151'>
            <path d='M109.576 219.151c60.419 0 109.573-49.156 109.573-109.576C219.149 49.156 169.995 0 109.576 0S.002 49.156.002 109.575c0 60.42 49.155 109.576 109.574 109.576zm0-204.151c52.148 0 94.573 42.426 94.574 94.575 0 52.149-42.425 94.575-94.574 94.576-52.148-.001-94.573-42.427-94.573-94.577C15.003 57.427 57.428 15 109.576 15z' />
            <path d='M94.861 156.507a7.502 7.502 0 0010.606 0 7.499 7.499 0 00-.001-10.608l-28.82-28.819 83.457-.008a7.5 7.5 0 00-.001-15l-83.46.008 28.827-28.825a7.5 7.5 0 00-10.607-10.608l-41.629 41.628a7.495 7.495 0 00-2.197 5.303 7.51 7.51 0 002.198 5.305l41.627 41.624z' />
        </svg>
    )
}

export function EmptyTransactionsIcon(props: any) {
    return (
        <svg
            width={75}
            height={76}
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...props}>
            <path
                d='M48.1 57.15l15.15 15.52a5.677 5.677 0 008.18 0c2.26-2.31 2.26-6.07 0-8.38L56.28 48.76'
                fill='#fff'
            />
            <path
                d='M48.1 57.15l15.15 15.52a5.677 5.677 0 008.18 0c2.26-2.31 2.26-6.07 0-8.38L56.28 48.76'
                stroke='#888'
                strokeWidth={2.315}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M61.31 31.94c0 16.81-13.3 30.44-29.7 30.44S1.91 48.75 1.91 31.94c0-16.81 13.3-30.44 29.7-30.44s29.7 13.63 29.7 30.44z'
                fill='#fff'
                stroke='#888'
                strokeWidth={2.315}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M8.68 31.98c0-3.25.64-6.35 1.8-9.16 1.16-2.82 2.84-5.35 4.92-7.48 2.08-2.13 4.55-3.85 7.3-5.04'
                stroke='#888'
                strokeWidth={2.315}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M39.39 25.28c-2.63-7.02-14.52-6.19-14.61 1.13-.04 3.27 3.8 4.78 7 5.28 11.69 1.85 8.46 12.84 0 12.42-6.42-.32-8.27-4.66-8.47-5.69'
                fill='#fff'
            />
            <path
                d='M39.39 25.28c-2.63-7.02-14.52-6.19-14.61 1.13-.04 3.27 3.8 4.78 7 5.28 11.69 1.85 8.46 12.84 0 12.42-6.42-.32-8.27-4.66-8.47-5.69M31.93 14.54v5.9M31.93 44.12v5.89'
                stroke='#888'
                strokeWidth={2.315}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export function CCIcon(props: any) {
    return (
        <svg
            width={81}
            height={81}
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...props}>
            <path
                d='M78.45 34.24L36.21 76.48c-.77.77-2.02.77-2.8 0L4.64 47.71c-.77-.77-.77-2.02 0-2.8L46.88 2.67c.77-.77 2.02-.77 2.8 0l28.77 28.77c.77.78.77 2.03 0 2.8zM10.47 53.54L55.51 8.5M15.82 58.9l45.05-45.04'
                stroke='#888'
                strokeWidth={2.315}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M65.86 76.99H6.11c-1.09 0-1.98-.89-1.98-1.98V34.32c0-1.09.89-1.98 1.98-1.98h59.74c1.09 0 1.98.89 1.98 1.98v40.69c.01 1.1-.88 1.98-1.97 1.98z'
                fill='#fff'
                stroke='#fff'
                strokeWidth={6.946}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M65.86 76.99H6.11c-1.09 0-1.98-.89-1.98-1.98V34.32c0-1.09.89-1.98 1.98-1.98h59.74c1.09 0 1.98.89 1.98 1.98v40.69c.01 1.1-.88 1.98-1.97 1.98z'
                stroke='#888'
                strokeWidth={2.315}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M28.5 42.58H13.45v7.87H28.5v-7.87zM23.12 66.01h-9.67M40.82 66.01h-9.67M58.53 66.01h-9.67M58.52 42.58h-7.87v7.87h7.87v-7.87z'
                stroke='#888'
                strokeWidth={2.315}
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}
